export const theme = {
    colors: {
      primaryBlack: '#1C1D21',
      secondaryBlack: '#696F80',
      white: '#fff',
      background: '#F4F6F9',
      primaryBlue: '#0042E4',
      grayedOut: '#CCD9FA'
    },
    fonts: {
    //   main: 'Arial, sans-serif',
    //   secondary: 'Verdana, sans-serif',
    },
    fontSize: {
        large: '20px',
        big: '16px',
        small: '14px',
        default: '12px',
    },
    fontWeight: {
        bold: '600',
        semiBold: '400',
        default: ''
    },
};

export const texts = {
    MODAL: {
        STEP_1: {
            TITLE: 'Yotpo Loyalty new VIP tier',
            SUBTITLE: 'What type of Flow would you like to send?'
        },
    },
    TABLE: {
        PREVIEW_BUTTON: 'Preview',
        STATUS_CHANGE_BUTTON: 'Enable'
    }
}

export const boxes = [
    {
        type: 'sms', 
        title: 'SMS', 
        description: 'Send a targeted message to your contacts through \n SMS.' 
    },
    {
        type: 'email', 
        title: 'Email', 
        description: 'Send a targeted message to your contacts \n through email.' 
    },
    {
        type: 'sms_and_email', 
        title: 'SMS & Email', 
        description: 'Send a targeted message to your contacts \n through sms and email.' 
    },
]